<template>
  <b-modal v-model="show" size="lg" title="Copiar menú" ok-title="Copiar"
    :ok-disabled="!canCopy || busy" :busy="busy" @ok="run" @shown="onShown">

    <b-row>
      <b-col md="6">
        <b-form-group label="Origen">
          <b-form-radio-group v-model="source" :options="sourceOptions" size="sm"
            buttons button-variant="outline-secondary" class="mb-2" @change="onSourceChange">
          </b-form-radio-group>
          <b-form-select v-model="srcId" :options="srcOptions" @change="loadSrcDetail"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Destino" description="Se escribe sobre este menú; no se crea uno nuevo.">
          <b-form-select v-model="dstId" :options="dstOptions"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group label="Qué copiar">
      <b-form-radio-group v-model="mode" size="sm" buttons button-variant="outline-primary">
        <b-form-radio value="full">Menú completo</b-form-radio>
        <b-form-radio value="categories">Categorías</b-form-radio>
        <b-form-radio value="products">Productos</b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <div v-if="mode !== 'full'">
      <b-form-input v-model="search" size="sm" placeholder="Buscar…" class="mb-2"></b-form-input>
      <div v-if="loadingDetail" class="text-center my-3"><b-spinner small></b-spinner></div>
      <div v-else class="border rounded p-2" style="max-height: 260px; overflow-y: auto;">
        <b-form-checkbox v-for="o in filteredOptions" :key="o.id" :value="o.id"
          v-model="selected" class="mb-1">
          {{ o.name }}
          <small v-if="o.hint" class="text-muted">· {{ o.hint }}</small>
        </b-form-checkbox>
        <div v-if="!filteredOptions.length" class="text-muted text-center py-2">
          <small>Sin resultados.</small>
        </div>
      </div>
      <small class="text-muted">{{ selected.length }} seleccionado(s)</small>
    </div>

    <b-alert show variant="info" class="mt-3 mb-0 py-2">
      <small>
        Los productos arrastran sus grupos de modificadores y las opciones de esos
        grupos. La copia hace <strong>upsert</strong>: los items se identifican por su
        producto del POS y las categorías y grupos por nombre, así que repetir la copia
        actualiza en vez de duplicar.
      </small>
    </b-alert>

    <b-alert v-if="result" show :variant="result.omitidos_sin_producto_pos || (result.avisos && result.avisos.length) ? 'warning' : 'success'"
      class="mt-2 mb-0 py-2">
      <small>
        Productos {{ result.productos_nuevos }} nuevos / {{ result.productos_actualizados }} actualizados ·
        Modificadores {{ result.modificadores_nuevos }}/{{ result.modificadores_actualizados }} ·
        Grupos {{ result.grupos_nuevos }}/{{ result.grupos_actualizados }} ·
        Categorías {{ result.categorias_nuevas }}/{{ result.categorias_actualizadas }}
        <span v-if="result.omitidos_sin_producto_pos">
          <br>{{ result.omitidos_sin_producto_pos }} sin producto del POS ligado: resuélvelos antes de publicar.
        </span>
      </small>
      <!-- Los avisos ya los mandaba el backend pero esta pantalla nunca los pintaba,
           así que una copia que fusionó dos productos o empató por nombre se veía
           idéntica a una limpia. -->
      <div v-if="result.avisos && result.avisos.length" class="mt-2 pt-2 border-top">
        <strong><small>{{ result.avisos.length }} aviso(s):</small></strong>
        <ul class="mb-0 pl-3">
          <li v-for="(a, i) in result.avisos" :key="i"><small>{{ a }}</small></li>
        </ul>
      </div>
    </b-alert>
  </b-modal>
</template>

<script>
import svc from '../../services/platformMenuService';

export default {
  name: 'platformMenuCopy',
  props: { menus: { type: Array, default: () => [] } },
  data() {
    return {
      show: false,
      busy: false,
      loadingDetail: false,
      source: 'platform',
      sourceOptions: [
        { value: 'platform', text: 'Otro menú' },
        { value: 'uber', text: 'Menú de Uber' }
      ],
      uberMenus: [],
      srcId: null,
      dstId: null,
      mode: 'full',
      search: '',
      selected: [],
      categories: [],
      items: [],
      result: null
    };
  },
  computed: {
    srcOptions() {
      const list = this.source === 'uber'
        ? this.uberMenus.map((m) => ({ value: m.uuid || m.id, text: m.name || m.uuid }))
        : this.menus.filter((m) => m.id !== this.dstId).map((m) => ({ value: m.id, text: m.name }));
      return [{ value: null, text: '— selecciona el origen —' }].concat(list);
    },
    dstOptions() {
      return [{ value: null, text: '— selecciona el destino —' }].concat(
        this.menus.filter((m) => !(this.source === 'platform' && m.id === this.srcId))
          .map((m) => ({ value: m.id, text: m.name }))
      );
    },
    filteredOptions() {
      const base = this.mode === 'categories' ? this.categories : this.items;
      const q = this.search.trim().toLowerCase();
      if (!q) return base;
      return base.filter((o) => (o.name || '').toLowerCase().includes(q));
    },
    canCopy() {
      if (!this.srcId || !this.dstId) return false;
      return this.mode === 'full' || this.selected.length > 0;
    }
  },
  watch: {
    mode() { this.selected = []; this.search = ''; }
  },
  methods: {
    open() { this.result = null; this.show = true; },
    onShown() {
      if (this.source === 'uber' && !this.uberMenus.length) this.loadUberMenus();
    },
    onSourceChange() {
      this.srcId = null; this.selected = []; this.categories = []; this.items = [];
      if (this.source === 'uber' && !this.uberMenus.length) this.loadUberMenus();
    },
    loadUberMenus() {
      svc.uberMenus().then((r) => { this.uberMenus = r.data || []; }).catch((e) => this.err(e));
    },
    // Carga categorías e items del origen para poder elegir qué copiar.
    loadSrcDetail() {
      this.selected = []; this.categories = []; this.items = [];
      if (!this.srcId) return;
      this.loadingDetail = true;
      const req = this.source === 'uber'
        ? Promise.all([svc.uberCategories(this.srcId), svc.uberItems(this.srcId)])
          .then(([c, i]) => ({
            categories: (c.data || []).map((x) => ({ id: x.id, name: this.uberTitle(x) })),
            items: (i.data || []).map((x) => ({
              id: x.id, name: this.uberTitle(x),
              hint: x.external_data ? 'POS ' + x.external_data : 'sin producto del POS'
            }))
          }))
        : svc.unified(this.srcId).then((r) => {
          const d = r.data || {};
          return {
            categories: (d.categories || []).map((c) => ({ id: c.id, name: c.name })),
            items: (d.items || []).filter((i) => String(i.type || '').toUpperCase() !== 'MODIFIER')
              .map((i) => ({
                id: i.id, name: i.name,
                hint: i.external_id > 0 ? 'POS ' + i.external_id : 'sin producto del POS'
              }))
          };
        });
      req.then((d) => { this.categories = d.categories; this.items = d.items; })
        .catch((e) => this.err(e))
        .finally(() => { this.loadingDetail = false; });
    },
    uberTitle(x) {
      return (x.title && x.title.translations && x.title.translations.en) || x.id;
    },
    run(evt) {
      if (evt) evt.preventDefault();
      if (!this.canCopy) return;
      const selection = this.mode === 'categories' ? { category_ids: this.selected }
        : this.mode === 'products' ? { item_ids: this.selected } : {};
      this.busy = true;
      const req = this.source === 'uber'
        ? svc.copyUberMenuToPlatform(this.srcId, this.dstId, selection)
        : svc.copyPlatformMenu(this.srcId, this.dstId, selection);
      req.then((r) => {
        this.result = r.data || {};
        this.$emit('copied', this.result);
        this.$bvToast.toast('Copia terminada', { title: 'Listo', variant: 'success', autoHideDelay: 4000 });
      }).catch((e) => this.err(e)).finally(() => { this.busy = false; });
    },
    err(e) {
      const d = e && e.response && e.response.data;
      const msg = typeof d === 'string' ? d : (d && d.error) || (e && e.message) || 'Error desconocido';
      this.$bvToast.toast(msg, { title: 'Error', variant: 'danger', autoHideDelay: 6000 });
    }
  }
};
</script>
